module.exports = __webpack_public_path__ + "static/media/ktc-sfo.fdaf3958.jpg";